import React from 'react';

interface FooterColumnProps {
  heading: string;
  children: React.ReactNode;
}

const FooterColumn = ({ heading, children }: Readonly<FooterColumnProps>) => (
  <section className="flex flex-col items-center pt-4 flex-wrap md:w-1/2 md:items-start lg:w-1/4 lg:content-center">
    <h4 className="text-foreground-muted font-bold text-lg mb-4">{heading}</h4>
    {children}
  </section>
);

export default FooterColumn;
